import * as Patient from './patient';

import { BaseItem, NullablePartial } from './common';

export enum Kind {
  Inpatient = 'INPATIENT',
  Outpatient = 'OUTPATIENT',
}

export interface BaseInpatientVisit {
  kind: Kind.Inpatient;
  ehrInformationId: string;
  patientLocation: string;
  ehrReferenceValue: string;
  providerTeamId: string;
  scheduledStartTime: null;
  scheduledEndTime: null;
  admissionTime: Date;
  dischargeTime: Date | null;
}

export interface BaseOutpatientVisit {
  kind: Kind.Outpatient;
  ehrInformationId: string;
  patientLocation: string | null;
  ehrReferenceValue: string | null;
  providerTeamId: null;
  scheduledStartTime: Date;
  scheduledEndTime: Date | null;
  admissionTime: null;
  dischargeTime: null;
}

export type BaseVisit = BaseInpatientVisit | BaseOutpatientVisit;

export type CreateValues = NullablePartial<BaseVisit>;
export type InpatientCreateValues = NullablePartial<BaseInpatientVisit>;

interface DeleteValues {
  deleted: boolean;
  deletedTimestamp: Date | null;
}

export type UpdateValues = Partial<CreateValues>;

export type UpsertValues = CreateValues;

export type Visit = BaseVisit & BaseItem & DeleteValues;
export type InpatientVisit = BaseInpatientVisit & BaseItem & DeleteValues;

export type VisitWithPatient = Visit & Patient.BasePatient;

export type DisplayableInpatientVisit = InpatientVisit &
  Patient.BasePatient & {
    patientEhrId: string;
    practiceId: string;
    practiceName: string;
    providerTeamName: string;
  };
